import { pageSizes } from '../constants'
import { generateUrlParams } from '../utils/generateUrlParams'

// Wallet
export const walletUrl = 'wallets'
export const createParaWalletUrl = () => `wallets/para`
export const editParaWalletUrl = () => `wallets/para`

// Game room
export const joinGameRoomUrl = (id) => `game-rooms/${id}/join`
export const getGameRoomsUrl = (filter) =>
  `game-rooms?${generateUrlParams(filter)}`

export const getGameRoomUrlById = (id) => `game-rooms/${id}`
export const getLineupByIdUrl = (id) => `teams/${id}`
export const getGameRoomFixturesUrl = (id) => `game-rooms/${id}/fixtures`
export const getJoinedGamesUrl = (id, page) =>
  `game-rooms/users/${id}?page=${page}&take=${pageSizes.small}&sort_by=createdAt&sort_order=DESC`
export const getTransactionUrl = (page, token) =>
  `payments?page=${page}&take=${pageSizes.small}&token=${token}`
export const getParticipantsUrl = (id, page, sortingOptions = {}) => {
  const sortingParams = generateUrlParams(sortingOptions) // This will turn { sort_by: "point", sort_order: "desc" } into "sort_by=point&sort_order=desc"
  return `game-rooms/${id}/participants?page=${page}&take=${pageSizes.medium}&${sortingParams}`
}
export const approvePayoutUrl = (id) => `game-rooms/${id}/process-pay-out`
export const triggerPayoutUrl = (id) => `game-rooms/${id}/trigger-payout`
export const processRunnerUpPayoutUrl = (id) =>
  `game-rooms/${id}/process-runner-ups-payout`
export const getGameRoomPointSummariesUrl = (id, pageNo) =>
  `game-rooms/${id}/points-summaries?page=${pageNo}&take=${pageSizes.medium}`

// Teams - User Built
export const userBuiltTeamUrl = 'teams'
export const getUserBuiltTeamUrlById = (id) => `teams/${id}`

// leagues
export const createAliasLeagueUrl = () => `leagues`
export const getAliasLeaguesUrl = (pageNo = 1) =>
  `leagues?page=${pageNo}&take=${pageSizes.super}`
export const getAliasLeagueUrlById = (id) => `leagues/${id}`
export const getFPLLeaguesUrl = (pageNo = 1) =>
  `fpl/leagues?page=${pageNo}&take=${pageSizes.super}`

// teams
export const getFantasyTeamsUrl = ({ leagueId, pageNo = 1 }) =>
  `fpl/teams?league_id=${leagueId}&page=${pageNo}&take=${pageSizes.super}`

export const getLeagueTeamsUrl = (id) => `fpl/teams?league_id=${id}`

// Players
export const getPlayersUrl = (filter) => {
  // page=${page}&take=20&sortBy=cost&sortOrder=DESC&league=${league}
  return `fpl/players?${generateUrlParams(filter)}`
}

export const getPlayerByIdUrl = (id) => `fpl/players/${id}`
export const getTeamsNextMatchByIdUrl = (teamId) =>
  `fpl/fixtures?team=${teamId}`
export const createTeamUrl = () => `teams`
export const editTeamUrl = (id) => `teams/${id}`
// Dashboard
export const investmentApiUrl = () => `reports/investments`
export const mostJoinedLeagueUrl = () => `reports/most-joined-leagues`
export const mostJoinedClubUrl = () => `reports/most-played-club`
export const countGameRoomsUrl = () => `reports/count-joined-game-rooms`
export const statisticsUrl = () => `reports/metric-scores`
export const highestPointGRUrl = () => `reports/highest-point`
export const last7GameStatsUrl = () => `reports/last-game-rooms`

// user
export const getUserDetailsUrl = () => `users/user/details`
export const getUpdateProfileUrl = (id) => `users/${id}`

// payment
export const requestCcdUrl = () => `payments/request-faucet`
export const runnerUpPayoutUrl = (gameRoomId) =>
  `game-rooms/${gameRoomId}/pay-participants`

// referrals
export const getReferralStatisticsUrl = () => `referrals/statistics`
export const getReferralsUrl = (page, startDate, endDate) => {
  const baseUrl = `referrals?page=${page}&take=${pageSizes.small}`
  const startDateParam = startDate !== '' ? `&startDate=${startDate}` : ''
  const endDateParam = endDate !== '' ? `&endDate=${endDate}` : ''

  return `${baseUrl}${startDateParam}${endDateParam}`
}
export const getRefferalCodeFromAliasUrl = (aliasCode) =>
  `referrals/aliases/${aliasCode}`

// Global Leaderboard
export const getLeaderTableUrl = ({
  pageNo,
  selectedMonth,
  selectedSeason,
}) => {
  let leaderBoardUrl = `x-points/leaderboard?page=${pageNo}&take=20`
  if (selectedMonth) leaderBoardUrl += `&month=${selectedMonth}`
  if (selectedSeason) leaderBoardUrl += `&seasonName=${selectedSeason}`
  return leaderBoardUrl
}

export const getUserLevelUrl = ({ selectedMonth, selectedSeason }) => {
  let userLevelUrl = `x-points/leaderboard/user-position?`
  if (selectedMonth) userLevelUrl += `&month=${selectedMonth}`
  if (selectedSeason) userLevelUrl += `&seasonName=${selectedSeason}`
  return userLevelUrl
}

// balances
export const getWalletBalanceUrl = () => `wallets/balances`
export const getAdminBalanceSummaryUrl = () => `reports/ccd-token/total-summary`
export const getUserBalancesUrl = (page = 1, take = pageSizes.small) =>
  `reports/ccd-token/user-balances?page=${page}&take=${take}`
export const getUserBalanceSummaryUrl = (userId) =>
  `reports/ccd-token/user/${userId}/balance`
export const getUserTransactionsUrl = (
  userId,
  page = 1,
  take = pageSizes.small
) => `reports/ccd-token/user/${userId}/transactions?page=${page}&take=${take}`
export const getNegativeBalancesUrl = (page = 1, take = pageSizes.small) =>
  `reports/ccd-token/negative-balances?page=${page}&take=${take}`

// withdrawal
export const getWithdrawalUrl = () => `wallets/process-withdrawal`

// otp
export const getOtpUrl = () => `otp/generate`

// notification
export const getSubscribeUrl = () => `notifications/subscribe`
// send notification
export const getSendNotificationUrl = () =>
  `notifications/send-in-app-notification`
// fetch notification
export const getNotificationsListUrl = (page) =>
  `notifications/list-messages?take=${pageSizes.small}&page=${page}`

// formation
export const getFormationUrl = () => `formations`

// autolineup
export const getAutoLineupUrl = (gameRoomId, formationId) =>
  `fpl/autolineup?gameRoomId=${gameRoomId}&formationId=${formationId}`

// game week api (matchweeks )
export const getMatchWeekUrl = (leagueIdentity) =>
  `fpl/rounds?leagueId=${leagueIdentity}`

// all games (fixtures )
export const getGamesUrl = (roundId, sportMonksLeagueId) =>
  `fpl/rounds/${roundId}?leagueId=${sportMonksLeagueId}`

// standings
export const getStandingsUrl = (seasonName, leagueIdOrIdentity) =>
  `fpl/standings/${leagueIdOrIdentity}?seasonName=${seasonName}`

// schedules
export const getSchedulesUrl = (leagueIdOrIdentity, seasonName, monthNumber) =>
  `fpl/schedules/${leagueIdOrIdentity}?seasonName=${seasonName}&monthNumber=${monthNumber}`

// getCommentariesUrl
export const getCommentariesUrl = (fixtureId) =>
  `fpl/fixtures/${fixtureId}/commentaries`

// getFixtureScore
export const getFixtureScore = (fixtureId) => `fpl/fixtures/${fixtureId}`

// Streaks
export const getStreaks = (pageNo = 1) =>
  `streaks?page=${pageNo}&take=${pageSizes.small}`
export const getCurrentStreaks = () => `streaks/active`
export const getStreaksSummary = () => `streaks/summary`
export const getStreakDetailsUrl = (id) => `streaks/${id}/game-rooms`
export const getStreakReviveUrl = (id) => `streaks/${id}/revive`

// creator
export const getMyGameRoomsUrl = (page = 1) =>
  `game-rooms/my-game-rooms?page=${page}&take=${pageSizes.small}`
export const countCreatedGameRoomsUrl = () => `reports/count-created-game-rooms`
export const flagGameRoom = (chosenGameRoomId) =>
  `game-rooms/${chosenGameRoomId}/flag`
export const changeVisibilityUrl = (chosenGameRoomId) =>
  `game-rooms/${chosenGameRoomId}/visibility`

// Brand
export const brandUrl = 'brand'
export const editBrandUrl = (id) => `brand/${id}`
export const getMyBrandUrl = () => 'brand/my-brand'
export const getBrandThemesUrl = () => 'brand/themes'
